// extracted by mini-css-extract-plugin
export default {"container":"container_gS1kE","title":"title_LNBOA","list":"list_Q9Ahi","item":"item_pptUN","itemSmall":"itemSmall_VPvq0","text":"text_iSxGb"};